/**
 * Checks if a page is currently active based on its start and end dates
 * @param {Object} page - The page object to check
 * @param {string|Date} [page.startDate] - Optional start date for the page
 * @param {string|Date} [page.endDate] - Optional end date for the page
 * @param {Date} [now=new Date()] - Current date to check against (defaults to current time)
 * @returns {boolean} - Returns true if the page is currently active, false otherwise
 */
const isPageActive = (page, now = new Date()) => {
    if (!page) {
        return false;
    }

    // Convert date strings to Date objects if needed
    const startDate = page.startDate ? new Date(page.startDate) : page?.content ? new Date(page.content.startDate) : null;
    const endDate = page.endDate ? new Date(page.endDate) : page?.content ? new Date(page.content.endDate) : null;

    // If a startDate is defined and it's in the future, page is not active yet
    if (startDate && now < startDate) {
        return false;
    }

    // If an endDate is defined and it's in the past, page is no longer active
    if (endDate && now > endDate) {
        return false;
    }

    // If we passed both checks, the page is active
    return true;
};

module.exports = { isPageActive };
